import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useScheduledMeetingContactsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IProjectedContact[]) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			filterRequest,
			excludedMeetingIds,
			forUserId,
			impersonationContext,
		}: {
			filterRequest: Api.IScheduledMeetingFilterRequest;
			excludedMeetingIds?: string[];
			forUserId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IProjectedContact[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { forUserId },
					urlPath: 'ScheduledMeeting/contacts',
				}),
				'POST',
				{ ...filterRequest, ...(excludedMeetingIds?.length ? { excludedIds: excludedMeetingIds } : {}) }
			);
		},
		onError,
		onSuccess,
	});
};
